// extracted by mini-css-extract-plugin
export default {"control-button":"control-button_control-button__vTsNz"};